import { render } from "./ProfileLibraries.vue?vue&type=template&id=a4a8b5f8"
import script from "./ProfileLibraries.vue?vue&type=script&lang=js"
export * from "./ProfileLibraries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__